/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CurrentUserService } from '../user/services/current-user.service';
import { LoginObserverService } from '../shared/authentication/login-observer.service';
import { ConfigurationService } from '../configuration/services/configuration.service';
import { User } from './models';
import { Router } from '@angular/router';
import { DateTimeService } from '../shared/datetime/datetime.service';
import { GenericModalService, ModalSettingsTemplate } from '../shared/generic-modal/generic-modal.service';
import { LoadingPanelService } from '../shared/loading-panel/loading-panel.service';
import { LinkHost } from '../system/models/link-host';
import { SystemService } from '../system/services/system.service';
import { SystemLinksService } from '../system/system-links/system-links.services';
import { DxDropDownButtonModule, DxDataGridModule } from 'devextreme-angular';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { merge } from 'rxjs';

@Component({
    selector: 'ep-user-sticker',
    templateUrl: './user-sticker-menu.component.html',
    styleUrls: ['./user-sticker-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDropDownButtonModule, DxDataGridModule, DxiColumnModule, DxTemplateModule]
})
export class UserStickerMenuComponent implements OnInit {
    private configurationService = inject(ConfigurationService);
    private currentUserService = inject(CurrentUserService);
    private systemService = inject(SystemService);
    private genericModalService = inject(GenericModalService);
    private loadingPanelService = inject(LoadingPanelService);
    private systemLinksService = inject(SystemLinksService);
    public router = inject(Router);
    public loginService = inject(LoginObserverService);
    public dateTimeService = inject(DateTimeService);

    @ViewChild('versionTemplate', { static: true }) private versionTemplate: TemplateRef<unknown>;

    public hostInfos: LinkHost[] = [];
    public activeEnvironment: string;
    public currentUser: User;
    public helpUrl: string;
    public documentationUrl: string;
    public environmentColor: string = null;

    public userActions: Array<{ id: number; text: string; icon: string; }> = [
        { id: 1, text: 'Log Out', icon: '/css/images/logout.svg' },
        { id: 1, text: 'Profile settings', icon: '/css/images/settings_account.svg' }
    ];
    public helpActions: Array<{ id: number; text: string; icon: string; }> = [
        { id: 1, text: 'Help', icon: '/css/images/contact_support.svg' },
        { id: 1, text: 'Documentation', icon: '/css/images/contact_support.svg' },
        { id: 1, text: 'Info', icon: '/css/images/info.svg' }
    ];
    public dropDownOptions = { minWidth: 147 };

    ngOnInit(): void {
        this.loginService.loginObserver.subscribe(() => void this.updateActiveEnvironment());
        this.currentUserService.userChangedObserver.subscribe(user => {
            this.currentUser = user;
            void this.updateActiveEnvironment();
        });

        void this.InitAsync();
    }

    private async InitAsync(): Promise<void> {
        [
            this.environmentColor,
            this.helpUrl,
            this.documentationUrl,
        ] = await Promise.all([
            this.configurationService.getEnvironmentColor(),
            this.systemLinksService.getHelpUrl(),
            this.systemLinksService.getDocumentationUrl(),
        ]);
    }

    onItemClick(e: any) {
        void this.executeAction(e.itemData.text);
    }

    private async executeAction(action: string) {
        if (action === 'Log Out') {
            this.loginService.userLogOut(true);
        }
        else if (action === 'Profile settings') {
            await this.router.navigate(['myprofile']);
        }
        else if (action === 'Help') {
            window.open(this.helpUrl, '_blank');
        }
        else if (action === 'Documentation') {
            window.open(this.documentationUrl, '_blank');
        }
        else if (action === 'Info') {
            await this.showCurrentVersionInfo();
        }
    }

    private async updateActiveEnvironment(): Promise<void> {
        this.activeEnvironment = await this.configurationService.getActiveEnvironment();
    }

    private async showCurrentVersionInfo() {
        await this.loadSystemInfo();
        try {
            const settings = new ModalSettingsTemplate();
            settings.size = 'lg';
            settings.windowClass = 'hugeModal';
            await this.genericModalService.openTemplate(this.versionTemplate, settings);
        } catch {
            // Ignore error if modal fails to open
        }
    }

    private async loadSystemInfo() {
        this.loadingPanelService.showLoadingPanelDirect('Loading...');
        this.hostInfos = await this.systemService.getVersionInfo();
        this.loadingPanelService.hideLoadingPanel();
    }
}
